<template>
  <tr :style="booking.checked ? 'background-color: rgba(106, 180, 85, 0.1);' : ''">
  
    <td>{{ booking.customer_name }} <br/> <span style="font-size: 0.8rem;">({{booking.integration}})</span></td>
    <td>
      {{ booking.trekksoft_booking_id }} 
      <br/> 
      <span style="font-size: 0.8rem;">({{booking.id}})</span>
      <!-- show alert on notes/remarks present in this booking -->
      <span v-if="booking.trekksoft_remarks !== '' && booking.trekksoft_remarks !== null">
        <br/>
        <i class="fa fa-fw fa-2x fa-exclamation-triangle text-warning" title="Esta reserva tiene notas"></i>
        <button v-b-modal="'show_' + booking.id" class="mx-1 border" :variant="'light'">Ver notas</button>
      </span>
      <span v-if="nextIsRelated" class="ml-2">
        <i class="fa fa-arrow-down text-info"></i>
      </span>
    </td>
    <td>{{ booking.trekksoft_hotel_name }}</td>
    <td>{{ booking.trekksoft_hotel_room }}</td>
    <td>
      <span>{{booking.trekksoft_activity_name}}</span> <br/> <span style="margin-left: 10px; color: #777;">({{ booking.trekksoft_availability_item_name }})</span>
    </td>
    <td>
      <span style="text-transform: uppercase">
        {{ booking.customer_language }}
        <country-flag
          v-if="booking.customer_language != 'otro'" 
          :country="booking.customer_language"
          size="small"
        />
        <span v-else>
          ?
        </span>
      </span>
    </td>
    <td>{{ booking.customer_adults }}</td>
    <td>{{ booking.customer_children }}</td>
    <td>
      {{
        booking.customer_adults +
        booking.customer_children
      }}
    </td>
    <td>
      {{booking.stop != null ? booking.stop.geo_point.name : '--'}}
    </td>
    <td>
      {{ booking.agency }} 
      <br> 
      <span style="font-size: 0.8rem;">
        ({{booking.channel}})
      </span>
    </td>
    <td>
      {{ booking.stop != null ? booking.stop.activity_group.name : '--' }}
    </td>
    <td class="flex col-1 align-content-center align-items-center align-self-center align">
      <div class="row col">
        <b-form-checkbox class="check" v-model="booking.checked" @change="toggleCheck()"  size="lg" name="check-button" switch></b-form-checkbox>

        <b-dropdown
          dropdown
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
          right
          class="float-right"
          style=""
        >
          <template v-slot:button-content>
            <i class="fa fa-ellipsis-v"></i>
          </template>
          <b-dropdown-item>
            <div v-b-modal="'show_' + booking.id">
              <i class="fa fa-eye fa-fw"></i> Ver todos los datos
            </div>
            <show-complete-booking-modal :bookingId="booking.id" />
          </b-dropdown-item>
          <b-dropdown-item>
            <div v-b-modal="'edit_' + booking.id">
              <i class="fa fa-pencil fa-fw"></i> Editar reserva
            </div>
            <edit-booking-modal :booking="booking" />
          </b-dropdown-item>
        </b-dropdown>
      </div>

    </td>
  </tr>
</template>

<script>
/* eslint-disable */
import Spinner from "vue-spinner/src/ScaleLoader.vue";
import ShowCompleteBookingModal from "../Modal/ShowCompleteBookingModal";
import { mapGetters } from "vuex";
import EditBookingModal from '../Modal/EditBookingModal';

export default {
  components: {
    Spinner,
    ShowCompleteBookingModal,
    EditBookingModal
  },
  props: {
    booking: {
      type: Object,
      required: true,
    },
    bookings: {
      type: Array,
      required: false
    },
    idx: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      check: this.booking.checked
    };
  },
  created() {
  },
  computed: {
    ...mapGetters(['groups']),
    ...mapGetters(['activeTab']),
    ...mapGetters(['activeOption']),
    nextIsRelated() {
          if ( this.idx < this.bookings.length-1 && this.bookings[this.idx+1].trekksoft_booking_id == this.booking.trekksoft_booking_id ) {
            return true
          }
          return false
        }
  },
  async mounted() {
    
  },
  methods: {
    async toggleCheck() {
      await this.$store.dispatch("bookings/toggleCheckedFlag", {id: this.booking.id})
    }
  },
};
</script>


<style scoped>
#checks_column i, #stop_column i {
  font-size: 14px;
  margin-left: 2px;
}
</style>